import { FunctionComponent, ReactNode } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-common-types";

import { Icon } from "@/components";
import { classNames } from "@/utils/classNames";

import { ChipTone } from "./outbox-card-status.helper";

const TONE_CLASSES: Record<ChipTone, string> = {
	success: "bg-status-success-light text-status-success",
	warning: "bg-status-warning-light text-status-wrong-person",
	error: "bg-status-error-light text-status-error",
	muted: "bg-status-info-light text-status-info",
	progress: "bg-status-progress-light text-status-progress",
};

interface LeadStatusChipProps {
	label: ReactNode;
	tone: ChipTone;
	icon?: IconDefinition;
}

/** The compact lead card's status pill (Completed / In progress / Paused / Not started …). */
export const LeadStatusChip: FunctionComponent<LeadStatusChipProps> = ({ label, tone, icon }) => (
	<span
		className={classNames(
			"inline-flex items-center gap-1 h-6 px-2 rounded-lg text-xs font-semibold whitespace-nowrap",
			TONE_CLASSES[tone]
		)}
	>
		{icon && <Icon className="w-3 h-3" icon={icon} />}
		{label}
	</span>
);
